// Catálogo de categorías de tienda (categoría del negocio, "Categoría de la
// tienda" en el panel). Capa PURA: lista única, valor interno estable +
// etiqueta legible, y helpers de mapeo/validación compartidos entre el panel
// (@plataforma/utils) y las Edge Functions del contrato Vimos Digital.
//
// - `valor`  : identificador interno estable que se guarda en
//              `empresa_perfil.categoria`. NUNCA exponer directo al usuario.
// - `etiqueta`: texto legible que se muestra en el panel y que se envía en
//              `data.category` del contrato Vimos (campo de texto libre).
//
// La categoría es OPCIONAL para crear/usar la tienda, pero se exige para que
// la tienda aparezca en el directorio de Vimos Digital (ver
// `determinarVisibilidadDirectorio` en ./vimos.js).

/** Opciones de categoría de la tienda (orden de exhibición). */
export const CATEGORIAS_TIENDA = [
  { valor: 'moda_y_ropa', etiqueta: 'Moda y ropa' },
  { valor: 'calzado', etiqueta: 'Calzado' },
  { valor: 'belleza_y_cuidado_personal', etiqueta: 'Belleza y cuidado personal' },
  { valor: 'accesorios_y_joyeria', etiqueta: 'Accesorios y joyería' },
  { valor: 'tecnologia_y_electronica', etiqueta: 'Tecnología y electrónica' },
  { valor: 'hogar_y_decoracion', etiqueta: 'Hogar y decoración' },
  { valor: 'alimentos_y_bebidas', etiqueta: 'Alimentos y bebidas' },
  { valor: 'salud_y_bienestar', etiqueta: 'Salud y bienestar' },
  { valor: 'deportes_y_fitness', etiqueta: 'Deportes y fitness' },
  { valor: 'juguetes_y_bebes', etiqueta: 'Juguetes y bebés' },
  { valor: 'mascotas', etiqueta: 'Mascotas' },
  { valor: 'papeleria_y_oficina', etiqueta: 'Papelería y oficina' },
  { valor: 'vehiculos_y_accesorios', etiqueta: 'Vehículos y accesorios' },
  { valor: 'otros', etiqueta: 'Otros' },
];

/** Categoría neutra usada cuando la tienda aún no tiene categoría configurada. */
export const CATEGORIA_TIENDA_POR_DEFECTO = 'otros';

/**
 * True si existe una categoría (string no vacío/espacios). Una tienda sin
 * categoría (null/''/undefined) NO cumple el requisito del directorio, pero
 * puede existir y operar fuera del directorio sin problema.
 * @param {unknown} categoria
 * @returns {boolean}
 */
export function categoriaTiendaValida(categoria) {
  return typeof categoria === 'string' && categoria.trim().length > 0;
}

/**
 * Etiqueta legible para mostrar la categoría actual. Devuelve la etiqueta del
 * catálogo si `categoria` es un valor interno conocido; si es un texto libre
 * heredado (datos anteriores al catálogo) devuelve el propio texto; null si no
 * hay categoría.
 * @param {unknown} categoria
 * @returns {string|null}
 */
export function etiquetaCategoriaTienda(categoria) {
  if (!categoriaTiendaValida(categoria)) return null;
  return CATEGORIAS_TIENDA.find((c) => c.valor === categoria)?.etiqueta ?? categoria;
}

/**
 * Valor de `category` garantizado para el payload del contrato Vimos: la
 * etiqueta legible para valores conocidos, el texto libre para valores
 * heredados, y la etiqueta de la categoría por defecto («Otros») cuando la
 * tienda aún no tiene categoría. NUNCA devuelve una cadena vacía: evita el
 * rechazo del webhook por `category` faltante/inválido.
 * @param {unknown} categoria
 * @returns {string}
 */
export function categoriaTiendaParaVimos(categoria) {
  return (
    etiquetaCategoriaTienda(categoria) ??
    CATEGORIAS_TIENDA.find((c) => c.valor === CATEGORIA_TIENDA_POR_DEFECTO).etiqueta
  );
}
